/**
 * Clamp et redigerbart antall (string fra NumericInput) til [0..max].
 * Tom string beholdes slik at brukeren kan slette og taste nytt tall.
 */
export const clampQty = (value: string, max: number): string => {
    if (value === '') return '';
    const parsed = parseFloat(value);
    if (isNaN(parsed)) return '';
    if (parsed > max) return String(max);
    return value;
};

/** Parse et redigerbart antall til tall — tom/ugyldig gir 0. */
export const parsedQty = (value: string): number => {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
};
